// ServiceNow Configuration
export const SERVICENOW_CONFIG = {
  USERNAME: 'svc_ges_ai_rest_user',
  PASSWORD: '=7MaqOciHVk<VwcCTkOs7GxMa+_8sg1p{v1,CNI^',
  // Backend endpoint to avoid CORS issues
  BACKEND_API: (typeof window !== 'undefined' && (window as any).BACKEND_API) 
    || '/api/create-ticket',
  // Direct ServiceNow URL (used by backend)
  SERVICENOW_URL: 'https://cemex.service-now.com/api/x_cmsad_ges_core/ges_ticket_support/create',
  // SERVICENOW_URL (test): 'https://cxtest.service-now.com/api/x_cmsad_ges_core/ges_ticket_support/create'
};
